const REGIONAL_INDICATOR_BASE = 0x1f1e6;

function getCodePoints(emoji: string): number[] {
  const codePoints: number[] = [];
  let index = 0;

  while (index < emoji.length) {
    const codePoint = emoji.codePointAt(index);

    if (codePoint === undefined) {
      break;
    }

    codePoints.push(codePoint);
    index += codePoint > 0xffff ? 2 : 1;
  }

  return codePoints;
}

export function isFlagEmoji(emoji: string): boolean {
  const codePoints = getCodePoints(emoji);

  return (
    codePoints.length === 2 &&
    codePoints.every(
      (codePoint) =>
        codePoint >= REGIONAL_INDICATOR_BASE &&
        codePoint <= REGIONAL_INDICATOR_BASE + 25,
    )
  );
}

export function getCountryCodeFromFlagEmoji(emoji: string): string | null {
  if (!isFlagEmoji(emoji)) {
    return null;
  }

  const codePoints = getCodePoints(emoji);

  return codePoints
    .map((codePoint) =>
      String.fromCharCode(codePoint - REGIONAL_INDICATOR_BASE + 65),
    )
    .join("")
    .toLowerCase();
}

export function getFlagImageUrl(emoji: string): string | null {
  const countryCode = getCountryCodeFromFlagEmoji(emoji);

  if (!countryCode) {
    return null;
  }

  return `https://flagcdn.com/w40/${countryCode}.png`;
}
